import { render, staticRenderFns } from "./dashboard2.vue?vue&type=template&id=4fde6f79"
import script from "./dashboard2.vue?vue&type=script&lang=js"
export * from "./dashboard2.vue?vue&type=script&lang=js"
import style0 from "./dashboard2.vue?vue&type=style&index=0&id=4fde6f79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports